/**
 * THE LIGHT A SCREEN WAITS IN, IN FRONT OF A PAGE OF THE NEW DESIGN (D-92, Miles 2026-10-24: "no matter what the
 * process/transition … and not matter what mode the user is in").
 *
 * Two screens stand in front of such a page before it is drawn: a route's guard while it decides
 * (src/components/routing/GuardLoading.tsx), then the page's door while its chunks arrive (./withPavilion.tsx). Both
 * wait in the light the page will open in: the visitor's choice in this browser, else their device's
 * (../previewTheme.ts). In front of a page under the app header, both hand that light and its switch to the header
 * while they wait, in a layout effect, as the page's frame does once it lands (./appPageLight.ts): the band never falls
 * back to noon between them, and its switch is there from the first frame.
 *
 * On the first download, with the door.
 */
import React from 'react';
import {
  readPreviewThemeChoice,
  resolvePreviewTheme,
  writePreviewThemeChoice,
  type PreviewTheme,
  type PreviewThemeChoice,
} from '../previewTheme';
import { publishAppPageLight } from './appPageLight';

/** The light to wait in; while `waiting` in front of an app page, handed to the app header with its switch. */
export function useWaitingLight(appChrome: boolean, waiting: boolean): PreviewTheme {
  const [choice, setChoice] = React.useState<PreviewThemeChoice>(readPreviewThemeChoice);
  const choose = React.useCallback((c: PreviewThemeChoice) => {
    writePreviewThemeChoice(c);
    setChoice(c);
  }, []);
  const theme = resolvePreviewTheme(choice);
  React.useLayoutEffect(
    () => (appChrome && waiting ? publishAppPageLight({ theme, choice, choose }) : undefined),
    [appChrome, waiting, theme, choice, choose],
  );
  return theme;
}
